import { ShareCardButton } from "@/components/ShareCardModal";

/** Shareable observation card — branded PNG (photo + QR + short link) for a
 * sighting. Thin wrapper over the generic ShareCardButton. */
export default function ObservationShareCard({ obsId, testid = "observation-card-btn" }) {
  return (
    <ShareCardButton
      metaUrl={`/nature/observations/${obsId}/card`}
      imageAlt="Shareable observation card"
      downloadName="naturepulse-observation-card.png"
      note="Print it, post it, or scan the QR — anyone with the link lands on this sighting."
      testid={testid}
      testidPrefix="observation-card"
    />
  );
}
